import { DepartmentLookup } from "./department-lookup.model";
import { FlagLookup } from "./flag-lookup.model";
import { OfficeLookup } from "./office-lookup.model";
import { OwnerClientTypeLookup } from "./owner-client-type-lookup.model";
import { EmployeeLookup } from "./employee-lookup.model";
import { ProjectManager1DepartmentLookup } from "./project-manager1-department-lookup.model";
import { ProjectManager1OfficeLookup } from "./project-manager1-office-lookup.model";

export class ProjectFilterLookupContainer {
    public departments: DepartmentLookup[] = [];
    public flags: FlagLookup[] = [];
    public offices: OfficeLookup[] = [];
    public ownerClientTypes: OwnerClientTypeLookup[] = [];
    public projectManager1Departments: ProjectManager1DepartmentLookup[] = [];
    public projectManager1Offices: ProjectManager1OfficeLookup[] = [];
    public projectManager1Employees: EmployeeLookup[] = [];
    public projectManager2Employees: EmployeeLookup[] = [];
    public taskManagerEmployees: EmployeeLookup[] = [];
    public projectAccountantEmployees: EmployeeLookup[] = [];
}
